<template lang="pug">
div
  el-row.margin(justify="space-between")
    el-col
      el-radio-group(
        :value="cadastro.cadastrante.pessoa.tipo",
        @change.native="clearDocumentos"
      )
        el-radio(
          label='PF'
        ) Pessoa Física
        el-radio(
          label='PJ'
        ) Pessoa Jurídica
  div.marginTopHeader
    app-pessoa-fisica-prefeitura(v-if="cadastro.cadastrante.pessoa.tipo === 'PF'", :pessoa='cadastro.cadastrante.pessoa', :nomeAba="nomeAba" :observer="observer")
    app-pessoa-juridica(v-if="cadastro.cadastrante.pessoa.tipo === 'PJ'", :pessoa='cadastro.cadastrante.pessoa', :nomeAba="nomeAba" :observer="observer")

  el-row.marginTopHeader
    el-row.margimBottom(:gutter="30")
      el-col(:span="24")
        validation-provider(rules="required" v-slot="{ errors }", :name="nomeAba + '/Solicitação'" mode="eager")
          app-label(label="Solicitação:")
          app-text-editor(
            name="Solicitação",
            v-model="cadastro.cadastrante.solicitacao",
            :class="{'box-erro-editor' : errors.length}"
          )
          span.help.erro {{ errors[0] }}
  el-row(:gutter="30")
    el-col(:span="24").marginTop
      validation-provider(rules="required" v-slot="{ errors }", :name="nomeAba + '/Oficio'")
        app-label(label="Ofício:")
        app-upload-area.uploadOficio(
          id="oficio"
          :target="urlUpload"
          :fileType="['doc', 'docx', 'jpeg', 'jpg', 'pdf', 'png']"
          :onSuccess="onSuccess"
          @download="download"
          v-model="cadastro.cadastrante.oficio"
          :documento="cadastro.cadastrante.oficio"
          @removerDocumento="removerDocumento"
         :errors="errors"
         :maxSize="25"
        )

  el-row
    app-endereco(:endereco='cadastro.cadastrante.pessoa.endereco', :nomeAba="nomeAba")
  el-row
    app-documentos(
      :maxSize='25',
      :valid-extensions="['doc', 'docx', 'jpeg', 'jpg', 'pdf', 'png']",
      :documentos="cadastro.cadastrante.documentos"
      :tiposDocumentos="documentos"
      :tiposDocumentosObrigatorios="documentosObrigatorios"
      :observer="observer",
      :aba="nomeAba"
    )

</template>

<script>
import AppEndereco from '../../../../../../components/AppEndereco'
import AppLabel from '../../../../../../components/AppLabel'
import AppTextEditor from '../../../../../../components/AppTextEditor'
import AppPessoaFisicaPrefeitura from '@/components/AppPessoaFisicaPrefeitura'
import AppPessoaJuridica from '@/components/AppPessoaJuridica'
import AppDocumentos from '../../../../components/cadastro/AppDocumentos'
import emptyPessoa from '../../empty/emptyPessoa'
import AppNotificacao from '@/components/mixins/AppNotificacao'
import { mapActions } from 'vuex'
import AppUploadArea from '@/components/AppUploadArea'
import FileHelper from '@/utils/fileHelper'

export default {
  mixins: [
    AppNotificacao
  ],

  props: ['cadastro', 'observer'],

  components: {
    AppTextEditor,
    AppPessoaJuridica,
    AppPessoaFisicaPrefeitura,
    AppEndereco,
    AppLabel,
    AppDocumentos,
    AppUploadArea
  },

  async beforeRouteLeave (to, from, next) {
    this.documentos = this.cadastro.cadastrante.pessoa.tipo === 'PF' ? await this.findDocumentos('cadastrantePf')
      : await this.findDocumentos('cadastrantePj')
    this.documentosObrigatorios = this.cadastro.cadastrante.pessoa.tipo === 'PF' ? await this.findDocumentos('obrigatorios/cadastrantePf')
      : await this.findDocumentos('obrigatorios/cadastrantePj')
    await this.observer.validate({ providerName: 'Cadastrante/Documentos', skipIfEmpty: false })
    next()
  },

  async created () {
    this.documentos = this.cadastro.cadastrante.pessoa.tipo === 'PF' ? await this.findDocumentos('cadastrantePf')
      : await this.findDocumentos('cadastrantePj')
    this.documentosObrigatorios = this.cadastro.cadastrante.pessoa.tipo === 'PF' ? await this.findDocumentos('obrigatorios/cadastrantePf')
      : await this.findDocumentos('obrigatorios/cadastrantePj')
  },

  data () {
    return {
      nomeAba: 'Cadastrante',
      documentos: [],
      documentosObrigatorios: [],
      urlUpload: this.$rotas.PUBLICO.UPLOAD
    }
  },

  methods: {
    ...mapActions({
      findDocumentos: 'tipoDocumento/findTiposDocumento',
      downloadDocumentos: 'documentoArrecadacao/download'
    }),

    clearDocumentos (event) {
      this.confirmBox('Ao alterar o tipo de pessoa você perderá os dados preenchidos. Deseja confirmar?', this.$messages.TITULO_WARNING,
        async () => {
          this.cadastro.cadastrante.pessoa.telefones = []
          if (this.cadastro.cadastrante.pessoa.tipo === 'PF') {
            this.cadastro.cadastrante.pessoa.email = null
            this.cadastro.cadastrante.pessoa.pessoaFisica.telefones = []
            this.cadastro.cadastrante.pessoa.pessoaFisica = emptyPessoa.pessoaFisica
          } else {
            this.cadastro.cadastrante.pessoa.pessoaJuridica = emptyPessoa.pessoaJuridica
            this.cadastro.cadastrante.pessoa.pessoaJuridica.telefones = []
          }
          this.cadastro.cadastrante.pessoa.tipo = event.target.value
          this.cadastro.cadastrante.documentos = []
        },
        () => {
        }, 'Sim', 'Não')
    },

    async download (id) {
      const documento = this.cadastro.cadastrante.oficio

      const arrayBuffer = await this.downloadDocumentos({ fileKey: documento.fileKey, id: documento.id })

      FileHelper.saveFile(arrayBuffer, documento.nomeOriginal)
    },

    removerDocumento () {
      this.cadastro.cadastrante.oficio = null
    },

    onSuccess (id, resumableFile, fileKey) {
      this.cadastro.cadastrante.oficio = {
        id: fileKey,
        fileKey: fileKey,
        nomeOriginal: resumableFile.fileName,
        tamanho: resumableFile.size,
        removed: false,
        tipoDocumento: { descricao: 'Ofício', codigo: 'OFICIO', tipo: 'OFICIO' },
        fileName: resumableFile.fileName
      }
    }
  },

  watch: {
    'cadastro.cadastrante.pessoa.tipo': {
      async handler (val) {
        if (val === 'PJ') {
          this.documentos = await this.findDocumentos('cadastrantePj')
          this.documentosObrigatorios = await this.findDocumentos('obrigatorios/cadastrantePj')
        } else {
          this.documentos = await this.findDocumentos('cadastrantePf')
          this.documentosObrigatorios = await this.findDocumentos('obrigatorios/cadastrantePf')
        }

        this.observer.reset()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.marginTop {
  margin-top: 10px;
}

.marginTopHeader {
  margin-top: 20px;
}

.margimBottom {
  margin-bottom: 10px;
}

.margimBottomTop {
  margin-top: 25px;
  margin-bottom: 25px;
}

.box-erro-editor {
  border-color: red !important;
  border: solid 1px;
}

.uploadOficio /deep/.upload-area /deep/.content {
  height: 3rem;
}
</style>



// WEBPACK FOOTER //
// src/screens/central/cadastros/para/areasPatrimoniais/components/Cadastrante.vue